// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/RelatoriosOS_ClientesResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Resposta de /relatorios/relatorios_os/clientes (chamado NS 2026-0084).
 *
 * Lista já filtrada pelo filtro global (franquias + período). Os totais são
 * somados no front.
 */
import type { RelatoriosOS_ClientesRow } from './RelatoriosOS_ClientesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type RelatoriosOS_ClientesResponseDados = RelatoriosOS_ClientesRow[];

export type RelatoriosOS_ClientesResponse = ApiResponse<RelatoriosOS_ClientesResponseDados>;

registerResponseContract('RelatoriosOS_ClientesResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      franquia_id:      { type: 'number',  required: true },
      franquia_nome:    { type: 'string',  required: true },
      cliente_id:       { type: 'number',  required: false },
      cliente_nome:     { type: 'string',  required: true },
      cliente_telefone: { type: 'string',  required: true },
      ordens:           { type: 'number',  required: true },
      total:            { type: 'number',  required: true },
      ticket_medio:     { type: 'number',  required: true },
      ultima_ordem_em:  { type: 'string',  required: false },
    },
  },
})
